"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _uuid = require("uuid");

var _constants = require("./constants");

var _storage = _interopRequireDefault(require("./storage"));

var BaseParams = /*#__PURE__*/function () {
  function BaseParams() {
    (0, _classCallCheck2.default)(this, BaseParams);
  }

  (0, _createClass2.default)(BaseParams, [{
    key: "getHttpCookie",
    value: function getHttpCookie() {
      var expires = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var cid = _storage.default.get(_constants.HTTP_COOKIE_KEY);

      if (!cid) {
        cid = (0, _uuid.v4)();

        _storage.default.set(_constants.HTTP_COOKIE_KEY, cid, expires);
      }

      return cid;
    }
    /**
     * 获取 sessionId
     * @param expires 缓存过期时间(分钟)
     * @param timezoneOffset 时区偏移值(秒)
     */

  }, {
    key: "getSessionId",
    value: function getSessionId() {
      var expires = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
      var timezoneOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var item = _storage.default.getRaw(_constants.SESSION_ID_KEY);

      var now = Date.now();
      var value = item.value;

      if (!value) {
        value = {};
      }

      var sid = value.sid || '';
      var isExpired = item.maxAge && item.maxAge < now;
      var isTimeExpired = +value.ite; // 创建新session

      if (!value.sid || isExpired) {
        value = {
          sid: (0, _uuid.v4)(),
          createAt: now,
          rn: 1,
          last_session_id: sid,
          session_create_type: 101
        };
        var _document = document,
            referrer = _document.referrer;

        if (referrer) {
          // reffer host 跟 站点host一致 则认为是站内跳转,不记录
          var host = window.location.host;

          var _URL = new URL(referrer),
              referrerHost = _URL.host;

          if (referrerHost !== host) {
            value.ref = referrer;
          }
        }

        if (isExpired) {
          if (isTimeExpired) {
            value.session_create_type = 103;
          } else {
            value.session_create_type = 102;
          }
        }
      } // utc0点当地时间


      var utcNow = new Date().setUTCHours(0, 0, 0, 0);

      if (utcNow < now) {
        // 第二天的0点
        utcNow += 86400 * 1000;
      }

      var utcTime = (utcNow - now) / 1000 / 60; // 店铺当前时间

      var storeNow = now + new Date().getTimezoneOffset() * 60000 + timezoneOffset * 1000; // 距离店铺当天0 点剩余时间

      var storeRemind = new Date(storeNow + 86400 * 1000).setHours(0, 0, 0, 0) - storeNow;
      var storeTime = storeRemind / 1000 / 60;
      var maxAge = Math.min(expires, utcTime, storeTime); // ite: isTimeExpired

      value.ite = utcTime < expires || storeTime < expires ? 1 : 0;

      _storage.default.set(_constants.SESSION_ID_KEY, value, maxAge);

      return value;
    }
  }, {
    key: "getSession",
    value: function getSession() {
      return _storage.default.getRaw(_constants.SESSION_ID_KEY);
    }
  }, {
    key: "upsetSessionRn",
    value: function upsetSessionRn(session) {
      var rn = session.rn || 1;

      _storage.default.append(_constants.SESSION_ID_KEY, {
        rn: rn + 1
      });

      return rn;
    }
  }, {
    key: "getHttpSearch",
    value: function getHttpSearch() {
      return window.location.search;
    }
  }, {
    key: "getUrlPath",
    value: function getUrlPath() {
      return window.location.pathname;
    }
  }, {
    key: "getMobile",
    value: function getMobile() {
      var ua = navigator.userAgent;
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
      var isAndroid = ua.match(/(Android)\s+([\d.]+)/);
      var isMobile = isIphone || isAndroid;
      return isMobile;
    }
  }, {
    key: "getIsMobile",
    value: function getIsMobile() {
      return this.getMobile() ? '101' : '102';
    }
  }, {
    key: "getWebsite",
    value: function getWebsite() {
      return this.getMobile() ? '102' : '101';
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return navigator.language;
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return _jsCookie.default.get(_constants.UID_KEY);
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      var _document$title;

      return (_document$title = document.title) === null || _document$title === void 0 ? void 0 : _document$title.substr(0, 255);
    }
  }, {
    key: "getScreenWidth",
    value: function getScreenWidth() {
      return window.screen.width;
    }
  }, {
    key: "getScreenHeight",
    value: function getScreenHeight() {
      return window.screen.height;
    }
  }, {
    key: "getPerformance",
    value: function getPerformance() {
      var performance = window.performance || window.webkitPerformance;
      var data = {};
      var timing = performance && performance.timing;

      if (performance && timing) {
        // 开始渲染的时间
        var firstPaint = 0;

        if (window.chrome && window.chrome.loadTimes) {
          firstPaint = window.chrome.loadTimes().firstPaintTime * 1000;
          firstPaint = firstPaint - timing.navigationStart;
        } // dns 查询时间


        data.dns = Math.ceil(timing.domainLookupEnd - timing.domainLookupStart); // TCP 握手时间

        data.tcp = Math.ceil(timing.connectEnd - timing.connectStart); // 网络加载时间

        data.request = Math.ceil(timing.responseEnd - timing.requestStart); // 接收到第一个字节时间(T0)

        data.connect = Math.ceil(timing.responseStart - timing.domainLookupStart); // 渲染处理

        data.processing = Math.ceil((timing.domComplete || timing.domLoading) - timing.domLoading); // 页面结构加载时间(T2)

        data.ready = Math.ceil(timing.domContentLoadedEventEnd - timing.navigationStart); // 加载时间(T3)

        data.load = Math.ceil(timing.loadEventEnd - timing.navigationStart); // 白屏时间

        data.white = Math.ceil(timing.responseStart - timing.navigationStart); // 开始渲染时间(T1)

        data.first_paint = firstPaint;

        if (!data.first_paint) {
          data.first_paint = timing.domLoading >= timing.navigationStart ? timing.domLoading - timing.navigationStart : 0;
        }

        data.first_paint = Math.ceil(data.first_paint); // 可交互时间

        data.active = Math.ceil(timing.domInteractive - timing.navigationStart);
      }

      return data;
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return document.domain;
    }
  }]);
  return BaseParams;
}();

var _default = new BaseParams();

exports.default = _default;